export default "__VITE_ASSET__JqBpyvkG__"